export default __webpack_public_path__ + "static/discount-7ce22ba756103ce6ea50cd39f6b59b69.png";